import { render } from "./notifications.vue.js?vue&type=template&id=5fcb95a0!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./notifications.vue?vue&type=template&id=5fcb95a0"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__